export default "__VITE_ASSET__YM8z29L___"